import api from '@/clientRequests/api'
import {
    GET_PRODUCT_MINIMAL_DATA,
    GET_PRODUCTS_DATA,
    GET_VARIANTS,
    GET_BUNDLE_CATALOG_DATA
} from './queries'
import { apiRoutes } from '@/config/globals'
import { buildError } from '@/utils/services'

export const getProductsData = async ({ productCodes = [], modifiers = [] }) => {
    try {
        const query = GET_PRODUCTS_DATA
        const variables = {
            productCodes,
            modifiers
        }

        const { products } = await api(apiRoutes.catalog, { query, variables })

        return products
    } catch (error) {
        const errorMessage = `Error fetching recommended product list with data: productCodes: ${JSON.stringify(productCodes)}, modifiers:  ${JSON.stringify(modifiers)}`
        buildError('[Catalog: getProductsData]:', errorMessage, error, false)
        return []
    }
}

export const getVariants = async (skus) => {
    try {
        const query = GET_VARIANTS
        const variables = { skus }
        const { variants } = await api(apiRoutes.catalog, { query, variables })

        return variants
    } catch (error) {
        const errorMessage = `Error fetching variants with data: skus: ${JSON.stringify(skus)}`
        buildError('[Catalog: getVariants]:', errorMessage, error, false)
        return []
    }
}

export const getProductMinimalData = async ({ productCodes = [], modifiers = [] }) => {
    try {
        const query = GET_PRODUCT_MINIMAL_DATA
        const variables = {
            productCodes,
            modifiers
        }

        const { products } = await api(apiRoutes.catalog, { query, variables })

        return products
    } catch (error) {
        const errorMessage = `Error fetching recommended product list with data: productCodes: ${JSON.stringify(productCodes)}, modifiers:  ${JSON.stringify(modifiers)}`
        buildError('[Catalog: getProductsData]:', errorMessage, error, false)
        return []
    }
}

export const getBundleCatalogData = async () => {
    try {
        const query = GET_BUNDLE_CATALOG_DATA
        const variables = {
            category: 'BUNDLES',
            modifiers: []
        }
        const { productsByCategory: { products } } = await api(apiRoutes.catalog, { query, variables })

        return products
    } catch (error) {
        const errorMessage = `Error fetching bundle catalog data`
        buildError('[Catalog: getBundleCatalogData]:', errorMessage, error, false)
        return []
    }
}
